export default [
  {
    path: "puntos-venta",
    name: "punto-venta",
    component: () =>
      import(/* webpackChunkName: "gestionPuntosVenta" */ "./listPuntoVentaView.vue"),
  },
];
